import React from 'react';
import {observer, inject} from 'mobx-react';
import {List} from '@enos/dpl';
import store from '../store';
import './index.less';

@inject((stores, props) => {
  const {sessionStore} = stores;
  return {
    ...props,
    sessionStore,
    uiStore: store
  };
})
@observer
class Item extends React.Component {
  render() {
    const {
      item: {id, name},
      uiStore,
      sessionStore,
      selectOUSuccessfully,
      showCurrent = true
    } = this.props;

    const currentId = sessionStore.isMobile ? uiStore.checkedId : (sessionStore.workingOrganization || {}).id;

    return (
      <List.Item {...{[['key'][0]]: id}} className='ou-item' onClick={() => (sessionStore.isMobile ? uiStore.setCheckedId(id) : selectOUSuccessfully(id))}>
        <span className='organization-name'>{name}</span>
        {(showCurrent || sessionStore.isMobile) && currentId === id ? <i className='dpl20_right_circle_so' /> : <i />}
      </List.Item>
    );
  }
}

export default Item;
